import React from "react";

export const Unauthorized = React.lazy(() => import('./Unauthorized'));
